@import "../variables.scss";

.countryCardRanks {
  .rankHeader {
    display: flex;
    flex-direction: row;

    .rankDescription {
      width: 60%;
      font-style: normal;
      font-weight: 400;
    }

    .rankControls {
      width: 40%;
    }
    @media (max-width: 1250px) and (min-width: 901px) {
      display: block;
      .rankDescription,
      .rankControls {
        width: auto;
      }

      .inlineButtons {
        width: 100%;
        justify-content: space-evenly;
      }
    }
    @include smallWidth {
      display: block;

      .rankDescription,
      .rankControls {
        width: auto;
      }

      .rankControls {
        margin-top: 0.5em;
      }

      .inlineButtons {
        font-size: 80%;
        width: 100%;
        justify-content: space-evenly;
      }
    }
  }

  .rankGraph {
    width: 100%;
    margin-top: 1em;
    margin-bottom: 0.5em;
  }
}
